import { DraftTaskGroup } from './task-groups.type';

export const initialDraftTaskGroup: DraftTaskGroup = {
  name: '',
  question: '',
};
